import { TimeSheetParams } from "../interfaces/time-sheet.interfaces";

export const timeSheetsQueryKeys = {
    all: ["time-sheets"] as const,
    list: (params?: TimeSheetParams) => ["time-sheets", params] as const,
};